
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17 5.21003C17 4.76003 17.54 4.54003 17.85 4.86003L20.64 7.65003C20.84 7.85003 20.84 8.16003 20.64 8.36003L17.85 11.15C17.54 11.46 17 11.24 17 10.79V9.00003H14C13.45 9.00003 13 8.55003 13 8.00003C13 7.45003 13.45 7.00003 14 7.00003H17V5.21003ZM9.99996 7.00003C9.44996 7.00003 8.99996 7.45003 8.99996 8.00003C8.99996 8.55003 9.44996 9.00003 9.99996 9.00003C10.55 9.00003 11 8.55003 11 8.00003C11 7.45003 10.55 7.00003 9.99996 7.00003ZM5.99996 7.00003C5.44996 7.00003 4.99996 7.45003 4.99996 8.00003C4.99996 8.55003 5.44996 9.00003 5.99996 9.00003C6.54996 9.00003 6.99996 8.55003 6.99996 8.00003C6.99996 7.45003 6.54996 7.00003 5.99996 7.00003ZM6.99996 17H9.99996C10.55 17 11 16.55 11 16C11 15.45 10.55 15 9.99996 15H6.99996V13.21C6.99996 12.76 6.45996 12.54 6.14996 12.86L3.35996 15.65C3.15996 15.85 3.15996 16.16 3.35996 16.36L6.14996 19.15C6.45996 19.46 6.99996 19.24 6.99996 18.79V17ZM14 17C14.55 17 15 16.55 15 16C15 15.45 14.55 15 14 15C13.45 15 13 15.45 13 16C13 16.55 13.45 17 14 17ZM18 17C18.55 17 19 16.55 19 16C19 15.45 18.55 15 18 15C17.45 15 17 15.45 17 16C17 16.55 17.45 17 18 17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-multiple-stop`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMultipleStop

    ```js
    <b-new-b-icon-multiple-stop />
    ```
</docs>


